import * as React from 'react';
import { UIHeading4 } from '@cian/ui-kit';

import * as style from './SimplePhone.css';

interface ISimplePhoneProps {
  phone: string;
}

export function SimplePhone({ phone }: ISimplePhoneProps) {
  return (
    <div className={style['container']}>
      <UIHeading4>{phone}</UIHeading4>
    </div>
  );
}
